import { render, staticRenderFns } from "./History.vue?vue&type=template&id=8edf60ee&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=8edf60ee&scoped=true&lang=css&"
import style1 from "./History.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edf60ee",
  null
  
)

export default component.exports